import { createAsyncThunk } from '@reduxjs/toolkit';

export const setHilighNotification = createAsyncThunk(
  'setHilighNotification',
  async (
    data: { notificationId: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    // Code
    let newNotificationId = '';
    if (
      getState().customerArea.hilightedNotificationId != data.notificationId
    ) {
      newNotificationId = data.notificationId;
    }

    if (newNotificationId) {
      dispatch(
        extra.apiSlice.endpoints.patchCustomerNotificationAsSeen.initiate({
          notificationId: data.notificationId,
        })
      );
    }

    return { newNotificationId };
  }
);
